"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendsToTarget = exports.SendsToTargets = exports.SetupType = exports.SetupTypesDescriptions = exports.SetupTypes = exports.ServiceFrequencyUnitLabels = exports.ServiceFrequencyUnit = exports.ServiceFrequencyUnits = exports.RentalPeriodUnitLabels = exports.RentalPeriodUnit = exports.RentalPeriodUnits = exports.ServiceEventType = exports.ServiceEventTypes = exports.ServiceEventStatus = exports.ServiceEventStatuses = exports.ServiceOrderStatus = exports.ServiceOrderStatusLabels = exports.ServiceOrderStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
// Service Order Statuses
exports.ServiceOrderStatuses = [
    'UNASSIGNED',
    'ASSIGNED',
    'ON_HOLD',
    'DELIVERED',
    'READY_FULL_PICKUP',
    'READY_PICKUP',
    'PICKED_UP_FULL',
    'PICKED_UP_EMPTY',
    'PICKED_UP',
    'DUMPED',
    'ON_SITE',
    'IN_PROGRESS',
    'COMPLETED',
];
exports.ServiceOrderStatusLabels = {
    UNASSIGNED: 'Unassigned',
    ASSIGNED: 'Assigned',
    ON_HOLD: 'On Hold',
    DELIVERED: 'Delivered',
    READY_FULL_PICKUP: 'Ready Pickup',
    READY_PICKUP: 'Ready Pickup',
    PICKED_UP_FULL: 'Picked Full',
    PICKED_UP_EMPTY: 'Picked Empty',
    PICKED_UP: 'Picked Up',
    DUMPED: 'Dumped',
    ON_SITE: 'On Site',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
};
exports.ServiceOrderStatus = typebox_1.Type.Union(exports.ServiceOrderStatuses.map((status) => typebox_1.Type.Literal(status)));
// Service Event types
exports.ServiceEventStatuses = ['pending', 'scheduled', 'cancelled', 'done', 'exception'];
exports.ServiceEventStatus = typebox_1.Type.Union(exports.ServiceEventStatuses.map((status) => typebox_1.Type.Literal(status)));
exports.ServiceEventTypes = [
    'initial-delivery',
    'visit',
    'synthetic', // For "virtual" events. Usually billing related.
    'final-pickup',
    'subscription-recurring',
];
exports.ServiceEventType = typebox_1.Type.Union(exports.ServiceEventTypes.map((type) => typebox_1.Type.Literal(type)));
// Rental Period Units
exports.RentalPeriodUnits = ['hour', 'day'];
exports.RentalPeriodUnit = typebox_1.Type.Union(exports.RentalPeriodUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.RentalPeriodUnitLabels = {
    hour: 'Hour',
    day: 'Day',
};
// Service Frequency Units
exports.ServiceFrequencyUnits = ['hour', 'day', 'week', 'month'];
exports.ServiceFrequencyUnit = typebox_1.Type.Union(exports.ServiceFrequencyUnits.map((unit) => typebox_1.Type.Literal(unit)));
exports.ServiceFrequencyUnitLabels = {
    hour: 'Hour',
    day: 'Day',
    week: 'Week',
    month: 'Month',
};
// Setup Types
exports.SetupTypes = ['FULL', 'NO_ASSET_DELIVERED'];
exports.SetupTypesDescriptions = {
    FULL: 'Shows every field value always',
    NO_ASSET_DELIVERED: 'No asset delivered hides irrelevant fields for service types where no physical asset is left on site. For example bulk pickup, the rear end does not sit on site for any longer than the service takes.',
};
exports.SetupType = typebox_1.Type.Union(exports.SetupTypes.map((value) => typebox_1.Type.Literal(value)));
// Communication Targets
exports.SendsToTargets = ['customer', 'vendor'];
exports.SendsToTarget = typebox_1.Type.Union(exports.SendsToTargets.map((target) => typebox_1.Type.Literal(target)));
//# sourceMappingURL=common-types.js.map